import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/clubSubscriptions',
        name: 'clubSubscriptions',
        meta: { sideMenuLabel: "Membership" },
        component: () => import("./views/clubSubscriptions.vue")
    },
];

export default routes;